import { createSlice } from "@reduxjs/toolkit";
import { deleteCustomerAPI } from "../../api/customer";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
}; 

const deleteCustomerSlice = createSlice({
  name: "deleteCustomer",
  initialState: data,
  reducers: {
   deleteCustomerSlice(state) {
      state.isLoading = true;
    },
   deleteCustomerSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    deleteCustomerSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    deleteCustomerSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});
export const deleteCustomerHandler = (id:any) => async (dispatch: any) => {
  try {
    dispatch(deleteCustomerAction.deleteCustomerSlice());
    const response: any = await deleteCustomerAPI(id);
    
    dispatch(deleteCustomerAction.deleteCustomerSliceSuccess(response));
  } catch (e: any) {
    dispatch(deleteCustomerAction.deleteCustomerSliceFailure(e?.response?.data));
  }
};
export default deleteCustomerSlice.reducer;
export const deleteCustomerAction = deleteCustomerSlice.actions;
